/* eslint-disable react/display-name */
import React from 'react'
import { Image } from 'antd'
import styled from 'styled-components'
import { TableListPage } from 'Components/common/Table'
import { appConfig } from 'config'
import { ProductData } from 'Store/dashboard/types'
import { numberWithComma } from 'helpers/format'
import { DashboardDataType, ImageFallback } from 'helpers/constanst'
import { MyTheme } from 'Components/common/Theme'

type Props = {
  data: ProductData[]
  type: DashboardDataType
}

const ProductTable: React.FunctionComponent<Props> = props => {
  const { data, type } = props

  const isPrice = type === DashboardDataType.SALE

  const renderImage = (img: string) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
  )

  const columns = [
    {
      title: 'อันดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1
      },
      width: '60px',
    },
    {
      title: 'รูปภาพ',
      dataIndex: 'photo',
      key: 'photo',
      render: renderImage,
      width: '70px',
    },
    {
      title: 'ผู้ผลิต',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
      width: '25%',
    },
    {
      title: isPrice ? 'จำนวน' : <Bold>จำนวน</Bold>,
      dataIndex: 'total_quantity',
      key: 'total_quantity',
      render: (data: number) => (isPrice ? numberWithComma(data) : <Bold>{numberWithComma(data)}</Bold>),
    },
    {
      title: !isPrice ? 'ยอดขาย' : <Bold>ยอดขาย</Bold>,
      dataIndex: 'total_price',
      key: 'total_price',
      render: (data: number) =>
        isPrice ? <Bold>{numberWithComma(data, true)}</Bold> : numberWithComma(data, true),
    },
  ]
  return <TableListPage columns={columns} datas={data} isLoading={false} size="small" scrollX={480} />
}

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 40px;
  height: 40px;
  object-fit: cover;
`

const Bold = styled.span`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`
export default ProductTable
